import { TIME_SCALES } from './summary/constants.tsx';

export const ABORT_ERR = 20;

export const stringifyOptions = {
	skipNull: true,
	sort: false,
} as const;

export const timescaleToTimePeriodBreakdownMap = {
	[TIME_SCALES.past48Hours]: {
		timeBreakdown: 'h',
		timePeriod: 'PT48H',
	},
	[TIME_SCALES.past7Days]: {
		timeBreakdown: 'd',
		timePeriod: 'P7D',
	},
	[TIME_SCALES.past14Days]: {
		timeBreakdown: 'd',
		timePeriod: 'P14D',
	},
	[TIME_SCALES.past30Days]: {
		timeBreakdown: 'd',
		timePeriod: 'P30D',
	},
	[TIME_SCALES.pastQuarterByDay]: {
		timeBreakdown: 'd',
		timePeriod: 'P3M',
	},
	[TIME_SCALES.pastQuarterByWeek]: {
		timeBreakdown: 'w',
		timePeriod: 'P3M',
	},
	[TIME_SCALES.pastYearByWeek]: {
		timeBreakdown: 'w',
		timePeriod: 'P1Y',
	},
	[TIME_SCALES.pastYearByMonth]: {
		timeBreakdown: 'm',
		timePeriod: 'P1Y',
	},
} as const;
